import type { ComplianceState } from "../api/adsApi/adsApi.interfaces";

export enum ContentType {
    PITCH = "PITCH",
    SALES_COLLATERAL = "SALES_COLLATERAL",
}

export enum ContentVisibility {
    PUBLIC = "PUBLIC",
    PRIVATE = "PRIVATE",
    ARCHIVED = "ARCHIVED",
}

export enum ContentStatus {
    ACTIVE = "ACTIVE",
    ARCHIVED = "ARCHIVED",
    ISOLATED = "ISOLATED",
}

export enum ContentAction {
    UPLOAD = "UPLOAD",
    DOWNLOAD = "DOWNLOAD",
}

export enum ArchivalDuration {
    SIX_MONTH = "SIX_MONTH",
    ONE_YEAR = "ONE_YEAR",
    TWO_YEAR = "TWO_YEAR",
    FIVE_YEAR = "FIVE_YEAR",
}

export interface ContentUser {
    userId: string;
    permissionType: "OWNER" | "VIEWER";
}

export interface ContentLabel {
    labelId: string;
    labelName: string;
}

export interface ContentVersion {
    version: number;
    fileName: string;
    fileSize: number;
    versionCreationDate: string;
    versionUploadedBy: string;
}

export enum ContentPreviewType {
    ORIGINAL = "ORIGINAL",
    PDF = "PDF",
}

export interface Content {
    contentId: string;
    contentTitle: string;
    contentType: ContentType;
    visibility: ContentVisibility;
    fileName: string;
    fileSize: number;
    fileFormat: string;
    contentStatus: ContentStatus;
    latestVersion: number;
    creationDate: string;
    lastModifiedDate: string;
    autoArchiveDate: string;
    archivalDuration: ArchivalDuration;
    totalViews: number;
    totalDownloads: number;
    totalExternalDownload: number;
    totalExternalShareCreated: number;
    externalShareGenerationStartDate: string;
    externalShareExpiryDate: string;
    externalSharePasscode: string;
    externalShareUrl: string;
    contentCategoryIds: string[];
    isPublishedInAapn: boolean;
    isHiddenInAapn: boolean;
    isFeaturedInAapn: boolean;
    assetDescription: string;
    shortDescription: string;
    contentNote: string;
    workbenchComplianceState: ComplianceState | null;
}
